import type { Id, TableNames } from "@convex/_generated/dataModel";
import { isValidConvexId } from "@plasma/utils/convex-id";

export function isConvexTableId<T extends TableNames>(
  _table: T,
  value: string
): value is Id<T> {
  return isValidConvexId(value);
}

export function toConvexTableId<T extends TableNames>(
  table: T,
  value: string
): Id<T> {
  if (!isConvexTableId(table, value)) {
    throw new Error(`Invalid ${table} id`);
  }
  return value;
}

export function toOptionalConvexTableId<T extends TableNames>(
  table: T,
  value: string | undefined
): Id<T> | undefined {
  if (value === undefined) {
    return undefined;
  }
  return toConvexTableId(table, value);
}

function isStorageId(value: string): value is Id<"_storage"> {
  return isValidConvexId(value);
}

export function toStorageId(value: string): Id<"_storage"> {
  if (!isStorageId(value)) {
    throw new Error("Invalid storage id");
  }
  return value;
}

/** Narrow upload POST JSON to a storage id. */
export function parseStorageUploadResponse(data: unknown): Id<"_storage"> {
  if (
    typeof data === "object" &&
    data !== null &&
    "storageId" in data &&
    typeof data.storageId === "string"
  ) {
    return toStorageId(data.storageId);
  }
  throw new Error("Invalid upload response");
}
